
<ng-template [ngIf]="isLoadingComplessivoMdp">
      <app-loading></app-loading>
</ng-template>


<div fxFlex="95%" class="mt-2">
  
    <div class="border-top-1 surface-border mt-5" style="text-align: center;">
      <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="p-button-outlined w-6 mt-3"></button>
    </div>
    
<div>
    